import { AxiosError } from 'axios';
import { createValidator, required } from '@unitedtraders/validators';
import { restErrorsToForm } from '@unitedtraders/microfrontend-common';
import { Instrument } from '../../../hooks/mapInstruments';
import { useWithdrawService } from '../../../hooks/useWithdrawService';
import { useAmountValidators } from '../../../components/AmountInput/hooks';
import { FormValues } from '.';

// error:
// t('exception:Invalid crypto address')

export const useFormProps = (instrument: Instrument) => {
  const withsrawService = useWithdrawService();
  const amountValidators = useAmountValidators(instrument);

  const validate = createValidator<FormValues>({
    amount: amountValidators,
    address: [required()],
  });

  return {
    validate,
    onSubmit: async (values: FormValues) => {
      try {
        await withsrawService.prepareUTTWithdraw(
          { value: values.amount, currency: instrument.currency },
          values.address
        );
        return;
      } catch (e: AxiosError | any) {
        return restErrorsToForm(e.response?.data || e);
      }
    },
  };
};
